module.exports = __webpack_public_path__ + "img/spinning-close.c05cd7a0.svg";